import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'line2Br'
})
export class Line2BrPipe implements PipeTransform {

  transform(value: string | string [] | boolean | Date): any {
    if (value && typeof value === 'string') {
      // console.log('value?', value);
      return value.replace(/\n/g, '<br/>');
    }

  }

}
